<mdb-spinner [spinnerType]="spinnerType" spinnerColor="blue"></mdb-spinner>


// WEBPACK FOOTER //
// ./src/app/shared/spin-icon/spin-icon.component.html